export const SINGLE_BLOG_ID = "SINGLE_BLOG_ID";
